import { Grid } from "@material-ui/core";
import { InputOptionMaster } from "App/Component/ui";
import React from "react";

export const PilihKodePenunjang = ({ formData, handleChange }) => {
  return (
    <>
      <Grid item sm={4}>
        <InputOptionMaster
          name='kode_penunjang'
          label='KODE PENUNJANG'
          id='kode_penunjang'
          value={formData.kode_penunjang}
          onChange={handleChange("kode_penunjang")}
          data={[
            {
              value: "",
              label: "Pilih",
            },
            {
              value: 1,
              label: "Radioterapi",
            },
            {
              value: 2,
              label: "Kemoterapi",
            },
            {
              value: 3,
              label: "Rehabilitasi Medik",
            },
            {
              value: 4,
              label: "Rehabilitasi Psikososial",
            },
            {
              value: 5,
              label: "Transfusi Darah",
            },
            {
              value: 6,
              label: "Pelayanan Gigi",
            },
            {
              value: 7,
              label: "Laboratorium",
            },
            {
              value: 8,
              label: "USG",
            },
            {
              value: 9,
              label: "Farmasi",
            },
            {
              value: 10,
              label: "Lain-Lain",
            },
            {
              value: 11,
              label: "MRI",
            },
            {
              value: 12,
              label: "HEMODIALISA",
            },
          ]}
          placeholder=''
        />
      </Grid>
    </>
  );
};
